export const LOCATION_ROLES = [
  "Location_admin",
  "Location_delegate",
  "Location_super_admin",
];

export const SUPER_ADMIN_ROLES = ["Mastermind_admin", "Location_super_admin"];